import { createContext, useContext, useState, useCallback } from 'react';

const PostActionBarContext = createContext({ isActive: false, activate: () => {}, deactivate: () => {} });

export function PostActionBarProvider({ children }) {
  const [isActive, setIsActive] = useState(false);
  const activate = useCallback(() => setIsActive(true), []);
  const deactivate = useCallback(() => setIsActive(false), []);
  return (
    <PostActionBarContext.Provider value={{ isActive, activate, deactivate }}>
      {children}
    </PostActionBarContext.Provider>
  );
}

export function usePostActionBar() {
  return useContext(PostActionBarContext);
}
